import React from "react";
import Header from "../Components/Header/header";
import Footer from "../Components/Footer/footer";

const PublicLayout = ({ children }) => {
    return (
        <div className="app">
            <Header />
            {children}
            <Footer />
        </div>
    );
};

export default PublicLayout;
